import type { Event } from '@patsnap/tahiti-core';

/**
 * 技术要点总结服务
 */
export interface FtoReportSummaryTechFeaturesService {
    /**
     * 总结技术要点加载状态
     */
    onSummaryLoading: Event<boolean>;
    /**
     * 获取技术要点总结结果, 并更新到模型中 {@link FtoReportRetrievalResultReportModel}
     */
    pullSummary(taskId: string): Promise<string>;
}

export const FtoReportSummaryTechFeaturesService = Symbol.for('FtoReportSummaryTechFeaturesService');
